import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const Navbar: React.FC = () => {
    return (
        <nav className="fixed top-0 w-full z-50 bg-background/80 backdrop-blur-md border-b border-border/50">
            <div className="container mx-auto px-4 h-16 flex items-center justify-between">
                <Link to="/" className="flex items-center gap-2 font-bold text-xl tracking-tight text-foreground">
                    <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary text-primary-foreground">
                        SL
                    </div>
                    <span>SigLLM</span>
                </Link>
                <div className="flex items-center gap-4">
                    <Button variant="ghost" asChild>
                        <Link to="/docs">Docs</Link>
                    </Button>
                    <Button variant="ghost" asChild>
                        <a href="/#demo">Demo</a>
                    </Button>
                    <Button variant="ghost" asChild>
                        <a href="/#pricing">Pricing</a>
                    </Button>
                    <Button variant="ghost" asChild>
                        <Link to="/login">Log in</Link>
                    </Button>
                    <Button asChild>
                        <Link to="/register">Start Free</Link>
                    </Button>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
